<ng-container>
  <c-container [fluid]="true" class="px-4">
    <button
      [cSidebarToggle]="sidebarId"
      cHeaderToggler
      class="btn d-lg-none pe-3"
      toggle="visible"
      style="margin-inline-start: -14px"
    >
      <svg cIcon name="cilMenu" size="lg"></svg>
    </button>

    <!-- Espacio vacío que empuja los botones hacia la derecha -->
    <div class="ms-auto"></div>

    <!-- Los 3 botones solicitados -->
    <c-header-nav class="d-flex align-items-center">
      <!-- 1. Botón de tema claro/oscuro -->
      <c-dropdown autoClose="true">
        <button cDropdownToggle class="btn btn-link nav-link py-0 px-2" title="Cambiar tema">
          <svg cIcon name="cilContrast" size="lg"></svg>
        </button>
          <ul cDropdownMenu alignment="end">
            <li>
              <button (click)="colorMode.set('light')" cDropdownItem class="d-flex align-items-center">
                <svg cIcon class="me-2" name="cilSun" size="lg"></svg>
                Light
              </button>
            </li>
            <li>
              <button (click)="colorMode.set('dark')" cDropdownItem class="d-flex align-items-center">
                <svg cIcon class="me-2" name="cilMoon" size="lg"></svg>
                Dark
              </button>
            </li>
            <li>
              <button (click)="colorMode.set('auto')" cDropdownItem class="d-flex align-items-center">
                <svg cIcon class="me-2" name="cilContrast" size="lg"></svg>
                Auto
              </button>
            </li>
          </ul>
      </c-dropdown>

      <!-- 3. Botón de cerrar sesión -->
      <button class="btn btn-link nav-link py-0 px-2" title="Cerrar sesión" (click)="logout()">
        <svg cIcon name="cilAccountLogout" size="lg"></svg>
      </button>
    </c-header-nav>
  </c-container>
</ng-container>
